// import html2pdf from "html2pdf.js";
import { orderInvoice } from "../services/Spares";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../styles/Invoice.css";

const Invoice = () => {
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [hdr, setHdr] = useState({});
  const [bill, setBill] = useState({});
  const [ship, setShip] = useState({});
  const { orderid } = useParams();
  const [invoiceReady, setInvoiceReady] = useState(false);

  useEffect(() => {
    console.log("Order ID:", orderid);
    if (orderid) {
      getOrderInvoice(orderid);
    }
  }, [orderid]);

  useEffect(() => {
    if (!invoiceReady) return;

    const printWindow = window.open("", "_blank", "width=800,height=1000");
    if (!printWindow) return;

    printWindow.document.open();
    printWindow.document.write(generateInvoiceHTML());
    printWindow.document.close();
    printWindow.focus();
  }, [invoiceReady]);

  const getOrderInvoice = async () => {
    try {
      setLoading(true);
      const res = await orderInvoice({ orderid });
      console.log("invoice", res);
      setdata(res?.data || []);
      setHdr(res?.hdr?.[0] || {});
      console.log(res?.hdr?.[0]);
      setBill(res?.Bill?.[0] || {});
      setShip(res?.Ship?.[0] || {});
      setInvoiceReady(true); // ✅ mark ready
    } catch (error) {
      console.error("Order tracking error:", error);
      setdata(null);
    } finally {
      setLoading(false);
    }
  };

  const generateInvoiceHTML = () => {
    const rows = data
      .map((row, i) => {
        const product = row.Products?.[0];
        if (!product) return "";

        return `
      <tr>
        <td>${i + 1}</td>
        <td>${product.sku || row.productid}</td>
        <td>${product.modelno}</td>
        <td>${row.orderqty}</td>
        <td>PCS</td>
        <td>${row.mrp}</td>
        <td>${row.dispercent ?? 0}</td>
        <td>${row.sdispercent ?? 0}</td>
        <td>${row.exdispercent ?? 0}</td>
        <td>${row.rate ?? 0}</td>
        <td>${row.gstpercent ?? 0}</td>
        <td>${row.totalamount}</td>
      </tr>
    `;
      })
      .join("");

    const igstTotal = data
      .reduce((s, r) => s + (r.igstamount || 0), 0)
      .toFixed(2);

    return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8" />
  <title>Invoice</title>
  <style>
    body { font-family: Arial; margin: 0; padding: 20px; }
    .invoice-container { max-width: 900px; margin: auto; }
    h2, h3 { text-align: center; margin: 4px 0; }
    .row { display: flex; justify-content: space-between; margin: 10px 0; font-size: 13px; }
    table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 12px; }
    th, td { border: 1px solid #000; padding: 4px; text-align: center; }
    td:nth-child(3) { text-align: left; }
    .invoice-summary { margin-top: 15px; font-size: 13px; }
    .summary-grid { display: grid; grid-template-columns: repeat(7, 1fr); border: 1px solid #000; }
    .summary-grid > div { border-right: 1px solid #000; padding: 6px; }
    .summary-grid > div:last-child { border-right: none; }
    .bank-details, .terms { border: 1px solid #000; border-top: none; padding: 8px; }
    .signature { text-align: right; margin-top: 30px; font-weight: bold; }
  </style>
</head>
<body onload="window.print();window.close()">
  <div class="invoice-container">
    <h3>TAX INVOICE</h3>
    <h2>PIXEL TOOLS PVT LTD</h2>

    <div class="row">
      <div>
        <b>Customer Name:</b> ${hdr.customer_details?.[0].firmname}<br/>
        <b>Mobile:</b> ${hdr.customer_details?.[0].mobile}<br/>
        <b>GSTIN:</b> ${hdr.customer_details?.[0].gst}<br/>
        <b>Address:</b> ${bill.flathouse}, ${bill.area}, ${bill.landmark}, ${bill.city}
      </div>
      <div>
        <b>Invoice No:</b> ${hdr.orderid}<br/>
        <b>Date:</b> ${new Date(hdr.orderdate).toLocaleDateString()}<br/>
        <b>Order No:</b> ${hdr.orderid}
      </div>
    </div>

    <table>
      <thead>
        <tr>
          <th>S No</th><th>HSN</th><th>Item Name</th><th>Qty</th><th>Unit</th>
          <th>Rate</th><th>Dis%</th><th>Spl%</th><th>Ext%</th>
          <th>Net Rate</th><th>GST%</th><th>Amount</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>

    <div class="invoice-summary">
      <div class="summary-grid">
        <div><div class="label">Taxable Amount</div><div>${hdr.amount}</div></div>
        <div><div class="label">IGST</div><div>${igstTotal}</div></div>
        <div><div class="label">Coupon</div><div>${hdr.couponamount || 0}</div></div>
        <div><div class="label">Wallet</div><div>${hdr.wallet || 0}</div></div>
        <div><div class="label">Delivery</div><div>${hdr.delivarycharges || 0}</div></div>
        <div><div class="label">Round Off</div><div>0</div></div>
        <div><div class="label"><b>Net</b></div><div><b>${hdr.netamount}</b></div></div>
      </div>

      <div class="bank-details">
        <b>Bank Details:</b> HDFC BANK LIMITED, Shamshabad, A/C NO : 50200014845307, IFSC : HDFC0002068
      </div>

      <div class="terms">
        <b>Terms & Conditions:</b>
        <ol>
          <li>No responsibility for transit damage.</li>
          <li>Goods once sold will not be taken back.</li>
          <li>Interest 24% p.a. if unpaid.</li>
          <li>Payment through banking only.</li>
          <li>Subject to Hyderabad Jurisdiction.</li>
        </ol>
      </div>

      <div class="signature">AUTHORIZED SIGNATURE</div>
    </div>
  </div>
</body>
</html>
`;
  };
  return (
    <>
      <div
        id="invoice-content"
        className="invoice-container"
        style={{
          marginTop: 20,
          maxWidth: 1000,
          marginLeft: "auto",
          marginRight: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h3 style={{ textAlign: "center" }}>TAX INVOICE</h3>
        <h2 style={{ textAlign: "center" }}>PIXEL TOOLS PVT LTD</h2>
        <div className="row">
          <div>
            <b>Customer Name:</b> {hdr?.customer_details?.[0]?.first_name}
            <br />
            <b>Mobile:</b> {hdr?.customer_details?.[0].mobile}
            <br />
            <b>GSTIN:</b> {hdr?.customer_details?.[0]?.gst}
            <br />
            <b>Address:</b> {bill.flathouse}, {bill.area}, {bill.landmark},{" "}
            {bill.city}
          </div>

          <div>
            <b>Invoice No:</b> {hdr?.orderid}
            <br />
            <b>Date:</b> {new Date(hdr?.orderdate).toLocaleDateString()}
            <br />
            <b>Order No:</b> {hdr?.orderid}
          </div>
        </div>
        <div style={{ width: "100%", overflowX: "auto" }}>
          <table className="table-container">
            <thead>

              <tr>
                <th>S No</th>
                <th>HSN</th>
                <th>Item Name</th>
                <th>Qty</th>
                <th>Unit</th>
                <th>Rate</th>
                <th>Dis%</th>
                <th>Spl%</th>
                <th>Ext%</th>
                <th>Net Rate</th>
                <th>GST%</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => {
                const product = row.Products?.[0];
                if (!product) return null;

                return (
                  <tr key={row.id}>
                    <td>{i + 1}</td>
                    <td>{product.sku || row.productid}</td>
                    <td>{product.modelno}</td>
                    <td>{row.orderqty}</td>
                    <td>PCS</td>
                    <td>{row.mrp}</td>
                    <td>{row.dispercent}</td>
                    <td>{row.sdispercent}</td>
                    <td>{row.exdispercent ?? 0}</td>
                    <td>{row.rate}</td>
                    <td>{row.gstpercent}</td>
                    <td>{Number(row.totalamount || 0).toFixed(2)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="invoice-summary" style={{ marginRight: 100 }}>
          <div className="summary-grid">
            <div>
              <div className="label">Taxable Amount (Exc GST)</div>
              <div className="value">{Number(hdr?.amount || 0).toFixed(2)}</div>
            </div>

            <div>
              <div className="label">IGST</div>
              <div className="value">
                {data.reduce((s, r) => s + (r.igstamount || 0), 0).toFixed(2)}
              </div>
            </div>

            <div>
              <div className="label">Coupon Amount</div>
              <div className="value">{Number(hdr?.couponamount || 0).toFixed(2)}</div>
            </div>

            <div>
              <div className="label">Wallet Amount</div>
              <div className="value">{Number(hdr?.wallet || 0).toFixed(2)}</div>
            </div>

            <div>
              <div className="label">Delivery Charges</div>
              <div className="value">{Number(hdr?.delivarycharges || 0).toFixed(2)}</div>
            </div>

            <div>
              <div className="label">Round Off</div>
              <div className="value">0</div>
            </div>

            <div>
              <div className="label">
                <b>Net Amount</b>
              </div>
              <div className="value">
                <b>{Number(hdr?.netamount || 0).toFixed(2)}</b>
              </div>
            </div>
          </div>

          <div className="bank-details">
            <b>Bank Details :</b> HDFC BANK LIMITED, Shamshabad, A/C NO :
            50200014845307, IFSC : HDFC0002068
          </div>

          <div className="terms">
            <b>Terms & Conditions :</b>
            <ol>
              <li>
                We are not responsible for Breakage/Damage/Shortage/Leakage in
                Transit.
              </li>
              <li>Responsibility ceases when goods delivered to carrier.</li>
              <li>Goods once sold will not be taken back.</li>
              <li>Interest 24% p.a. if invoice not paid before due date.</li>
              <li>Payment through banking only (RTGS/NEFT).</li>
              <li>Company never accepts cash. Report if asked: 9849660551</li>
              <li>Subject to Hyderabad Jurisdiction.</li>
            </ol>
          </div>

          <div className="signature">AUTHORIZED SIGNATURE</div>
        </div>
      </div>
    </>
  );
};
export default Invoice;
